import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("xmd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function mediaUrl(path) {
  if (!path) return "";
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path.startsWith("/api/")) return `${BACKEND_URL}${path}`;
  if (path.startsWith("/")) return `${BACKEND_URL}${path}`;
  return `${API}/files/${path}`;
}

export function fmtMoney(cents) {
  return `$${((cents || 0) / 100).toFixed(2)}`;
}

export function fmtHour(h) {
  const hr = ((Number(h) % 24) + 24) % 24;
  const ampm = hr < 12 ? "AM" : "PM";
  const h12 = hr % 12 === 0 ? 12 : hr % 12;
  return `${h12}:00 ${ampm}`;
}

export function fmtTimeStr(t) {
  if (!t && t !== 0) return "";
  const [h, m = "00"] = String(t).split(":");
  const hr = parseInt(h, 10);
  if (Number.isNaN(hr)) return String(t);
  const ampm = hr < 12 ? "AM" : "PM";
  const h12 = hr % 12 === 0 ? 12 : hr % 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
}

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
